
/**
 * 输入插件重构 @fay 2017
 */

import Events from 'events';
import Smiley from '../../../component/smiley/index.js';
import TopOrder from '../topOrder/index.js';
// import Certificate from '../certificate/index.js';
import util from '../../../lib/util.js';

const LOG_C = 'inputplugin';
const isPC = util.isPC();
export default class Plugins extends Events {

  constructor(app) {
    super();
    this.app = app;
    this.log = app.log;
    this.view = app.view;
    this.pluginConfig = this.app.appConfig.get('plugin') || {};
    this.init();
    this.bindEvents();
  }

  init() {
    const param = this.pluginConfig;
    // const bridge = this.app.bridge;
    // 订单
    // if (!param.hideOrder) this.selectOrder();
    // 相册上传图片
    // if (false) this.selectPhoto();
    // // 拍照上传
    // if (false) this.camera();
    // 表情
    if (!param.hideExpression) this.smiley();
    // 结束云客服
    if (!param.hideEndService) this.closeSession();
    // 隐藏插件
    if (param.hidePlus) this.view.footer.hidePlus();
    // 刷新按钮
    // if (this.app.appConfig.get('base').env !== 'prod') this.refresh();
    // 语音按钮
    if (param.hideVoice) {
      this.app.view.footer.input.useKeyboard();
      this.app.view.footer.input.hideVoice();
      this.emit('load');
    }
  }

  bindEvents() {
    const app = this.app;
    // 进入人工客户，显示结束服务
    app.on(app.events.CHANNEL_OCS_ONLINE, () => {
      this.view.footer.showTargetPlugin('closeSession');
    });
    // 进入机器人流程，隐藏结束服务
    app.on(app.events.CHANNEL_ROBOT_ONLINE, () => {
      this.view.footer.hideTargetPlugin('closeSession');
    });
  }

  selectOrder() {
    const inputPanel = this.view.footer;
    const baseConfig = this.app.appConfig.get('base');
    const order = new TopOrder({
      from: baseConfig.from,
      app: this.app,
      inputPanel,
      container: inputPanel.$plugin,
    });

    order.on('message', () => {
      order.hide();
      this.view.footer.resize();
    });

    const $pluginBoard = inputPanel.$plugin.find('.J_Plugins');

    inputPanel.on('hidePlugin', () => {
      order.hide();
    });

    order.on('show', () => {
      $pluginBoard.hide();
      this.view.footer.resize();
    });

    order.on('hide', () => {
      $pluginBoard.show();
      this.view.footer.resize();
    });

    order.on('render', () => {
      this.view.resize();
      this.view.scrollToBottom();
    });

    this.view.addPlugin({
      title: '选择宝贝',
      name: 'selectOrder',
      icon: 'commodi',
      action: () => {
        order.show();
        this.log.send({
          c: LOG_C,
          d: 'order',
        });
      },
    });
  }

  camera() {
    this.view.addPlugin({
      title: '拍照',
      name: 'camera',
      icon: 'camera',
      action: () => {
        this.__photo('camera');
        this.log.send({
          c: LOG_C,
          d: 'camera',
        });
      },
    });
  }


  selectPhoto() {
    this.view.addPlugin({
      title: '图片',
      name: 'selectphoto',
      icon: 'photo',
      action: () => {
        this.__photo('photo');
        this.log.send({
          c: LOG_C,
          d: 'photo',
        });
      },
    });
  }

  __photo(type) {
    const bridge = this.app.bridge;
    let $image = null;
    bridge.photo({
      type,
      bizCode: 'alxm',
      onSelected: (d) => {
        // 图片预览，使用的本地url
        this.app.postMessage({
          type: 'image',
          body: {
            side: 'right',
            text: `<img src="${d.url}" class="base64-img" >`,
          },
        }).then((ret) => {
          $image = ret.body;
          this.app.view.body.append($image);
        });
      },
    }).then((res) => {
      const url = res.url;
      $image.find('img').attr('cdn-src', url);
      this.app.view.footer.submit(url, 'image', false, true);
    }, (err) => {
      if (err === 'NO_PERMISSION') {
        bridge.toast(`请开启${type === 'camera' ? '拍照' : '访问相册'}权限哦`);
      }
    });
  }

  smiley() {
    // const config = this.app.appConfig.get('appConfig');
    const inputPanel = this.view.footer;
    const size = this.app.param.size || { width: window.innerWidth };
    const smiley = new Smiley({
      log: this.log,
      container: inputPanel.$plugin,
      size,
    });

    this.app.view.smiley = smiley;

    // 兜底表情，如果没有自定义则默认用小蜜的
    // const defaultSmiley = [
    //   {
    //     type: 'xm',
    //     icon: 'https://gw.alicdn.com/tps/TB1N2jXPpXXXXbmXFXXXXXXXXXX-37-41.png',
    //     name: 'XIAO_MI',
    //   },
    // ];
    // const smileyList = (config.customSmiley && config.customSmiley.length > 0) ?
    //   config.customSmiley : defaultSmiley;

    // // 添加小蜜自定义表情
    // smiley.addCustomSmiley(smileyList);

    smiley.on('message', (ev) => {
      // 发送表情
      inputPanel.submit(ev.text, ev.type);
    });

    inputPanel.on('hidePlugin', () => {
      smiley.hide();
    });

    const $pluginBoard = inputPanel.$plugin.find('.J_Plugins');
    smiley.on('show', () => {
      $pluginBoard.hide();
      this.view.resize();
      this.view.scrollToBottom();
    });

    smiley.on('hide', () => {
      $pluginBoard.show();
      this.view.resize();
      this.view.scrollToBottom();
    });

    this.view.addPlugin({
      title: 'Emoji',
      name: 'smiley',
      icon: 'face',
      action: () => {
        smiley.show();
        this.log.send({
          c: LOG_C,
          d: 'smiley',
        });
      },
    });
    inputPanel.$emojiBtn.on(isPC ? 'click' : 'tap', () => {
      inputPanel.showPlugin();
      smiley.show();
    });
  }

  closeSession() {
    this.view.addPlugin({
      title: '结束服务',
      name: 'closeSession',
      icon: 'exit',
      action: () => {
        this.app.channel.ocs.offline();
        this.log.send({
          c: LOG_C,
          d: 'close_session',
        });
      },
    });
  }
  /**
   * 刷新按钮
   * @memberOf Plugins
   */
  refresh() {
    this.view.addPlugin({
      title: 'Refresh',
      name: 'refresh',
      icon: 'roll',
      action: () => {
        location.reload();
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/module/inputplugins/repo.js